<template>
  <div id="jobs" class="jf-jobs section padding-bottom-65">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="section-headline centered margin-top-45 margin-bottom-45">
            <h3>Jobs at the Fair</h3>
            <span>Open positions you can apply for at the event</span>
            <p class="jf-jobs__preview-note">This is just a preview—new job opportunities are added regularly as we get closer to the event.</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="jf-jobs__table-wrap">
            <table class="jf-jobs__table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Company</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="job in jobs" :key="job.JobFairJobId">
                  <td>{{ job.Title }}</td>
                  <td>{{ job.CompanyName }}</td>
                  <td>{{ job.LocationName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JobFairJobs",
  props: {
    jobs: { type: Array, required: true }
  }
};
</script>

<style lang="scss" scoped>
.jf-jobs {
  background: #fff;
  padding-top: 25px;

  &__preview-note {
    margin-top: 12px;
    font-size: 14px;
    font-style: italic;
    color: #6b6b6b;
  }

  &__table-wrap {
    overflow-x: auto;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
  }

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;

    th, td {
      padding: 14px 18px;
      text-align: left;
      border-bottom: 1px solid #f0f0f0;
    }

    th {
      background: #f7f8fc;
      font-weight: 600;
      color: #1f1f1f;
    }

    tr:last-child td {
      border-bottom: none;
    }

    tr:hover td {
      background: #fafbff;
    }
  }
}

@media (max-width: 768px) {
  .jf-jobs__table {
    font-size: 14px;

    th, td {
      padding: 10px 12px;
    }
  }
}
</style>
